import { Keys, OrderResponseMessage, TempOrder } from '@eih-netbroker/common';
import { useCallback } from 'react';
import { useLocale } from '../../../../../context/NbLocalizationContext';
import { NbButton } from '../../../../../shared/components/button/Button';
import { OrderFormSourceComponent } from '../../../types/orderTypes';
import { useOrderState } from '../../OrderStateContext';
import classes from './OrderModalBottomNavigationButtons.module.scss';

type OrderFooterSecondaryButtonProps = {
  isLoading: boolean;
  tempOrder?: TempOrder;
  warnings?: OrderResponseMessage[];
  onBack: (shouldResetFormToDefaults: boolean) => void;
  onClose: (shouldResetFormToDefaults: boolean) => void;
  sourceComponent?: OrderFormSourceComponent;
};

export const OrderFooterSecondaryButton = ({
  tempOrder,
  isLoading,
  onBack,
  warnings,
  onClose,
  sourceComponent,
}: OrderFooterSecondaryButtonProps) => {
  const { translation } = useLocale();
  const { smsCodeError } = useOrderState();
  const handleBack = useCallback(() => onBack(false), [onBack]);
  const handleClose = useCallback(() => onClose(false), [onClose]);

  if (
    tempOrder?.showSmsConfirmation &&
    smsCodeError?.errorCode === Keys.ErrorCode.twoFactor.orderSmsConfirmationError
  ) {
    return (
      <NbButton
        disabled={isLoading}
        onClick={handleBack}
        className={classes.button}
      >
        {translation.orderModal.twoFactorConfirm.restart}
      </NbButton>
    );
  }

  if (
    !(
      warnings?.some(message => message.msgType === 'error') ||
      tempOrder?.messages?.some(m => m.msgType === 'error') ||
      smsCodeError?.errorCode === Keys.ErrorCode.twoFactor.orderSmsConfirmationError
    )
  ) {
    return (
      <NbButton
        variant="outlined"
        data-testid={tempOrder?.showConfirmation ? 'order-confirm-back-button' : undefined}
        disabled={isLoading}
        onClick={sourceComponent === OrderFormSourceComponent.Modal ? handleBack : handleClose}
        className={classes.button}
      >
        {translation.general.back}
      </NbButton>
    );
  }

  // Return empty div so the primary button will float to the right
  return <div />;
};
